import PressingStrikes from 'assets/images/aa/pressingstrikes.png';
import DecisiveStrikes from 'assets/images/aa/decisivestrikes.png';
import ChromaticWarding from 'assets/images/aa/chromaticwarding.png';
import FieldOfWar from 'assets/images/aa/fieldofwar.png';
import FortifyingEmpowerment from 'assets/images/aa/fortifyingempowerment.png';
import QuickSteps from 'assets/images/aa/quicksteps.png';
import ImmeasurableEmpowerment from 'assets/images/aa/immeasureableempowerment.png';
import ElusiveNature from 'assets/images/aa/elusivenature.png';
import PreciseStrikes from 'assets/images/aa/precisestrikes.png';
import ArcanePlunder from 'assets/images/aa/arcaneplunder.png';
import EmpoweredMending from 'assets/images/aa/empoweredmending.png';
import EmpoweredVitality from 'assets/images/aa/empoweredvitality.png';
import WillOfTheSublime from 'assets/images/aa/willofthesublime.png';
import TaintedWeapons from 'assets/images/aa/taintedweapons.png';
import SteadfastFaith from 'assets/images/aa/steadfastfaith.png';
import Resolve from 'assets/images/aa/resolve.png';
import UnbindingCharm from 'assets/images/aa/unbindingcharm.png';
import AvoidEntrapment from 'assets/images/aa/avoidentrapment.png';
import DivineLuster from 'assets/images/aa/divineluster.png';
import AvoidEntanglements from 'assets/images/aa/avoidentanglements.png';
import Transcendence from 'assets/images/aa/transcendence.png';
import Flanking from 'assets/images/aa/flanking.png';
import PrelateAtArms from 'assets/images/aa/prelateatarms.png';
import RearGuard from 'assets/images/aa/rearguard.png';
import Enchanter from 'assets/images/aa/enchanter.png';
import Liberation from 'assets/images/aa/liberation.png';
import Deliverance from 'assets/images/aa/deliverance.png';
import Vindication from 'assets/images/aa/vindication.png';
import EtherealEscape from 'assets/images/aa/etherealescape.png';
import PointBlankShot from 'assets/images/aa/pointblankshot.png';
import AtTheGates from 'assets/images/aa/atthegates.png';
import CoverofDusk from 'assets/images/aa/coverofdusk.png';
import SleuthofBears from 'assets/images/aa/sleuthofbears.png';
import IdolofDarkRejuvenation from 'assets/images/aa/idolofdarkrejuvenation.png';
import ShimmeringInvocation from 'assets/images/aa/shimmeringinvocation.png';
import BloodShroud from 'assets/images/aa/bloodshroud.png';
import Rally from 'assets/images/aa/rally.png';
import StallTheAdvance from 'assets/images/aa/stalltheadvance.png';
import PrinceofTerror from 'assets/images/aa/princeofterror.png';
import BoilBlood from 'assets/images/aa/boilblood.png';
import UnearthlyApprentice from 'assets/images/aa/unearthlyapprentice.png';
import HuntingHawk from 'assets/images/aa/huntinghawk.png';
import ToolsatHand from 'assets/images/aa/toolsathand.png';
import MasterAssassin from 'assets/images/aa/masterassassin.png';
import SpiritofYggdrasil from 'assets/images/aa/spiritofyggdrasil.png';
import EyesofSet from   'assets/images/aa/eyesofset.png';
import EmissaryofElysium from 'assets/images/aa/emissaryofelysium.png';
import ScarabKnight from 'assets/images/aa/scarabknight.png';
import OneLastPush from 'assets/images/aa/onelastpush.png';
import PrimeInitiative from   'assets/images/aa/primeinitiative.png';
import FromTheBeyond from 'assets/images/aa/fromthebeyond.png';
import SupremeLich from 'assets/images/aa/supremelich.png';
import Clout from 'assets/images/aa/clout.png';
import Upheaval from 'assets/images/aa/upheaval.png';
import Castration from 'assets/images/aa/castration.png';
import FeralGrowl from 'assets/images/aa/feralgrowl.png';
import LeviathansCall from 'assets/images/aa/leviathanscall.png';
import ShieldofBrilliance from 'assets/images/aa/shieldofbrilliance.png';
import CrimsonSuccor from 'assets/images/aa/crimsonsuccor.png';
import Rout from 'assets/images/aa/rout.png';
import DeliberateReprisal from 'assets/images/aa/deliberatereprisal.png';
import QuickeningDeath from 'assets/images/aa/quickeningdeath.png';
import Cacodemon from 'assets/images/aa/cacodemon.png';
import FuneralRites from 'assets/images/aa/funeralrites.png';
import DeadlyDraw from 'assets/images/aa/deadlydraw.png';
import BoneShatter from 'assets/images/aa/boneshatter.png';
import SinsoftheFlesh from 'assets/images/aa/sinsoftheflesh.png';
import Maul from 'assets/images/aa/maul.png';
import Constriction from 'assets/images/aa/constriction.png';
import Inclusion from 'assets/images/aa/inclusion.png';
import DeathLord from 'assets/images/aa/deathlord.png';
import Besiege from 'assets/images/aa/besiege.png';
import Counterweight from 'assets/images/aa/counterweight.png';
import EnslavingFire from 'assets/images/aa/enslavingfire.png';
import BindingsoftheSkylord from  'assets/images/aa/bindingsoftheskylord.png';
import WitheredBlasphemy from 'assets/images/aa/witheredblasphemy.png';
import JarringShot from 'assets/images/aa/jarringshot.png';
import WithoutWarning from 'assets/images/aa/withoutwarning.png';
import Disfigure from 'assets/images/aa/disfigure.png';
import SurgeofBile from 'assets/images/aa/surgeofbile.png';
import ForkedLightning from 'assets/images/aa/forkedlightning.png';
import BlessedSoul from 'assets/images/aa/blessedsoul.png';
import SanguineInfusion from 'assets/images/aa/sanguineinfusion.png';
import Assail from 'assets/images/aa/assail.png';
import ChampionSpirit from 'assets/images/aa/championspirit.png';
import FeedingThePyre from 'assets/images/aa/feedingthepyre.png';
import Renegotiation from 'assets/images/aa/renegotiation.png';
import DecaysOfNature from 'assets/images/aa/decaysofnature.png';
import Crossfire from 'assets/images/aa/crossfire.png';
import WhatitTakes from 'assets/images/aa/whatittakes.png';
import ChokingPowder from 'assets/images/aa/chokingpowder.png';
import VisionsoftheSky from 'assets/images/aa/visionsofthesky.png';
import CoilsoftheSerpent from 'assets/images/aa/coilsoftheserpent.png';
import WanderingDisciple from 'assets/images/aa/wanderingdisciple.png';
import VoidofMadness from 'assets/images/aa/voidofmadness.png';
import BattlefieldCommander from 'assets/images/aa/battlefieldcommander.png';
import SustainingWrath from 'assets/images/aa/sustainingwrath.png';
import RedShadowsofXotli from 'assets/images/aa/redshadowsofxotli.png';
import RuinousPower from 'assets/images/aa/ruinouspower.png';
import NightmareCompanions from 'assets/images/aa/nightmarecompanions.png';
import RunningShot from 'assets/images/aa/runningshot.png';
import Determination from 'assets/images/aa/determination.png';
import DanceofDeath from 'assets/images/aa/danceofdeath.png';
import UrsineBond from 'assets/images/aa/ursinebond.png';
import Lull from 'assets/images/aa/lull.png';
import LightthePath from  'assets/images/aa/lightthepath.png';
import UnwillingSacrifice from 'assets/images/aa/unwillingsacrifice.png';
import BreakThrough from 'assets/images/aa/breakthrough.png';
import MasteratArms from 'assets/images/aa/masteratarms.png';
import HungerforMore from 'assets/images/aa/hungerformore.png';
import RingofFire from 'assets/images/aa/ringoffire.png';
import ChillingBreath from 'assets/images/aa/chillingbreath.png';
import UnleashtheUnderworld from 'assets/images/aa/unleashtheunderworld.png';
import GeneralAA from 'assets/images/aa/generalaa.png';
import ArchetypeAA from 'assets/images/aa/archetypeaa.png';
import ClassAA from 'assets/images/aa/classaa.png';
import { AocArchetype, AocClasses } from '@pvplevelup/core/dist/interfaces/ICharacter';

export enum AAType {
  General,
  Archetype,
  Class
}

let aaMap: Record<string, string> = {
  "GeneralAA": GeneralAA,
  "ArchetypeAA": ArchetypeAA,
  "ClassAA": ClassAA,
  "Pressing Strikes": PressingStrikes,
  "Decisive Strikes": DecisiveStrikes,
  "Chromatic Warding": ChromaticWarding,
  "Field of War": FieldOfWar,
  "Fortifying Empowerment": FortifyingEmpowerment,
  "Quick Steps": QuickSteps,
  "Immeasurable Empowerment": ImmeasurableEmpowerment,
  "Elusive Nature": ElusiveNature,
  "Precise Strikes": PreciseStrikes,
  "Will of the Sublime": WillOfTheSublime,
  "Unbinding Charm": UnbindingCharm,
  "Transcendence": Transcendence,
  "Enchanter": Enchanter,
  "Ethereal Escape": EtherealEscape,
  "Empowered Mending": EmpoweredMending,
  "Steadfast Faith": SteadfastFaith,
  "Divine Luster": DivineLuster,
  "Prelate at Arms": PrelateAtArms,
  "Deliverance": Deliverance,
  "Arcane Plunder": ArcanePlunder,
  "Tainted Weapons": TaintedWeapons,
  "Avoid Entrapment": AvoidEntrapment,
  "Flanking": Flanking,
  "Liberation": Liberation,
  "Empowered Vitality": EmpoweredVitality,
  "Resolve": Resolve,
  "Avoid Entanglements": AvoidEntanglements,
  "Rear Guard": RearGuard,
  "Vindication": Vindication,
  "Sleuth of Bears": SleuthofBears,
  "Spirit of Yggdrasil": SpiritofYggdrasil,
  "Feral Growl": FeralGrowl,
  "Maul":Maul,
  "Surge of Bile":SurgeofBile,
  "Vision of the Sky":VisionsoftheSky,
  "Ursine Bond":UrsineBond,
  "At the Gates": AtTheGates,
  "Tools at Hand": ToolsatHand,
  "Upheaval": Upheaval,
  "Bone Shatter": BoneShatter,
  "Without Warning": WithoutWarning,
  "What it Takes":WhatitTakes,
  "Determination":Determination,
  "Cover of Dusk": CoverofDusk,
  "Master Assassin": MasterAssassin,
  "Castration": Castration,
  "Sins of the Flesh": SinsoftheFlesh,
  "Disfigure": Disfigure,
  "Choking Powder":ChokingPowder,
  "Dance of Death":DanceofDeath,
  "Point Blank Shot": PointBlankShot,
  "Hunting Hawk": HuntingHawk,
  "Clout": Clout,
  "Deadly Draw": DeadlyDraw,
  "Jarring Shot": JarringShot,
  "Crossfire":Crossfire,
  "Running Shot":RunningShot,
  "Rally": Rally,
  "One Last Push": OneLastPush,
  "Rout": Rout,
  "Besiege": Besiege,
  "Assail": Assail,
  "Battlefield Commander":BattlefieldCommander,
  "Break Through":BreakThrough,
  "Blood Shroud": BloodShroud,
  "Scarab Knight": ScarabKnight,
  "Crimson Succor": CrimsonSuccor,
  "Death Lord": DeathLord,
  "Sanguine Infusion": SanguineInfusion,
  "Void of Madness":VoidofMadness,
  "Unwilling Sacrifice":UnwillingSacrifice,
  "Boil Blood": BoilBlood,
  "Unleash the Underworld": UnleashtheUnderworld,
  "Cacodemon": Cacodemon,
  "Bindings of the Skylord": BindingsoftheSkylord,
  "Renegotiation": Renegotiation,
  "Ruinous Power":RuinousPower,
  "Ring of Fire": RingofFire,
  "Stall the Advance": StallTheAdvance,
  "Prime Initiative": PrimeInitiative,
  "Deliberate Reprisal": DeliberateReprisal,
  "Counterweight": Counterweight,
  "Champion Spirit": ChampionSpirit,
  "Sustaining Wrath": SustainingWrath,
  "Master at Arms": MasteratArms,
  "Prince of Terror": PrinceofTerror,
  "From the Beyond": FromTheBeyond,
  "Quickening Death": QuickeningDeath,
  "Enslaving Fire": EnslavingFire,
  "Feeding the Pyre": FeedingThePyre,
  "Red Shadows of Xotli": RedShadowsofXotli,
  "Hunger for More": HungerforMore,
  "Unearthly Apprentice": UnearthlyApprentice,
  "Supreme Lich": SupremeLich,
  "Funeral Rites": FuneralRites,
  "Withered Blasphemy": WitheredBlasphemy,
  "Decays of Nature": DecaysOfNature,
  "Nightmare Companions": NightmareCompanions,
  "Chilling Breath": ChillingBreath,
  "Shimmering Invocation": ShimmeringInvocation,
  "Emissary of Elysium": EmissaryofElysium,
  "Shield of Brilliance": ShieldofBrilliance,
  "Inclusion": Inclusion,
  "Blessed Soul": BlessedSoul,
  "Wandering Disciple": WanderingDisciple,
  "Light the Path": LightthePath,
  "Idol of Dark Rejuvenation": IdolofDarkRejuvenation,
  "Eyes of Set": EyesofSet,
  "Leviathan's Call": LeviathansCall,
  "Constriction": Constriction,
  "Forked Lightning": ForkedLightning,
  "Coils of the Serpent": CoilsoftheSerpent,
  "Lull": Lull,
}

let aaMapInfo: Record<string, {type:AAType, size:number}> = {
  "Pressing Strikes": {type:AAType.General, size:1},
  "Decisive Strikes": {type:AAType.General, size:1},
  "Chromatic Warding": {type:AAType.General, size:1},
  "Field of War": {type:AAType.General, size:1},
  "Fortifying Empowerment": {type:AAType.General, size:1},
  "Quick Steps": {type:AAType.General, size:1},
  "Immeasurable Empowerment": {type:AAType.General, size:1},
  "Elusive Nature": {type:AAType.General, size:1},
  "Precise Strikes": {type:AAType.General, size:1},
  "Will of the Sublime": {type:AAType.Archetype, size:1},
  "Unbinding Charm": {type:AAType.Archetype, size:1},
  "Transcendence": {type:AAType.Archetype, size:1},
  "Enchanter": {type:AAType.Archetype, size:1},
  "Ethereal Escape": {type:AAType.Archetype, size:1},
  "Empowered Mending": {type:AAType.Archetype, size:1},
  "Steadfast Faith": {type:AAType.Archetype, size:1},
  "Divine Luster": {type:AAType.Archetype, size:1},
  "Prelate at Arms": {type:AAType.Archetype, size:1},
  "Deliverance": {type:AAType.Archetype, size:1},
  "Arcane Plunder": {type:AAType.Archetype, size:1},
  "Tainted Weapons": {type:AAType.Archetype, size:1},
  "Avoid Entrapment": {type:AAType.Archetype, size:1},
  "Flanking": {type:AAType.Archetype, size:1},
  "Liberation": {type:AAType.Archetype, size:1},
  "Empowered Vitality": {type:AAType.Archetype, size:1},
  "Resolve": {type:AAType.Archetype, size:1},
  "Avoid Entanglements": {type:AAType.Archetype, size:1},
  "Rear Guard": {type:AAType.Archetype, size:1},
  "Vindication": {type:AAType.Archetype, size:1},
  "Sleuth of Bears": {type:AAType.Class, size:2},
  "Spirit of Yggdrasil": {type:AAType.Class, size:2},
  "Feral Growl": {type:AAType.Class, size:1},
  "Maul":{type:AAType.Class, size:1},
  "Surge of Bile":{type:AAType.Class, size:1},
  "Vision of the Sky":{type:AAType.Class, size:2},
  "Ursine Bond":{type:AAType.Class, size:1},
  "At the Gates": {type:AAType.Class, size:2},
  "Tools at Hand": {type:AAType.Class, size:2},
  "Upheaval": {type:AAType.Class, size:1},
  "Bone Shatter": {type:AAType.Class, size:1},
  "Without Warning": {type:AAType.Class, size:1},
  "What it Takes":{type:AAType.Class, size:2},
  "Determination":{type:AAType.Class, size:1},
  "Cover of Dusk": {type:AAType.Class, size:2},
  "Master Assassin": {type:AAType.Class, size:2},
  "Castration": {type:AAType.Class, size:1},
  "Sins of the Flesh": {type:AAType.Class, size:1},
  "Disfigure": {type:AAType.Class, size:1},
  "Choking Powder":{type:AAType.Class, size:2},
  "Dance of Death":{type:AAType.Class, size:1},
  "Point Blank Shot": {type:AAType.Class, size:2},
  "Hunting Hawk": {type:AAType.Class, size:2},
  "Clout": {type:AAType.Class, size:1},
  "Deadly Draw": {type:AAType.Class, size:1},
  "Jarring Shot": {type:AAType.Class, size:1},
  "Crossfire":{type:AAType.Class, size:2},
  "Running Shot":{type:AAType.Class, size:1},
  "Rally": {type:AAType.Class, size:2},
  "One Last Push": {type:AAType.Class, size:2},
  "Rout": {type:AAType.Class, size:1},
  "Besiege": {type:AAType.Class, size:1},
  "Assail": {type:AAType.Class, size:1},
  "Battlefield Commander":{type:AAType.Class, size:2},
  "Break Through":{type:AAType.Class, size:1},
  "Blood Shroud": {type:AAType.Class, size:2},
  "Scarab Knight": {type:AAType.Class, size:2},
  "Crimson Succor": {type:AAType.Class, size:1},
  "Death Lord": {type:AAType.Class, size:1},
  "Sanguine Infusion": {type:AAType.Class, size:1},
  "Void of Madness":{type:AAType.Class, size:2},
  "Unwilling Sacrifice":{type:AAType.Class, size:1},
  "Boil Blood": {type:AAType.Class, size:2},
  "Unleash the Underworld": {type:AAType.Class, size:2},
  "Cacodemon": {type:AAType.Class, size:1},
  "Bindings of the Skylord": {type:AAType.Class, size:1},
  "Renegotiation": {type:AAType.Class, size:1},
  "Ruinous Power":{type:AAType.Class, size:2},
  "Ring of Fire": {type:AAType.Class, size:1},
  "Stall the Advance": {type:AAType.Class, size:2},
  "Prime Initiative": {type:AAType.Class, size:2},
  "Deliberate Reprisal": {type:AAType.Class, size:1},
  "Counterweight": {type:AAType.Class, size:1},
  "Champion Spirit": {type:AAType.Class, size:1},
  "Sustaining Wrath": {type:AAType.Class, size:2},
  "Master at Arms": {type:AAType.Class, size:1},
  "Prince of Terror": {type:AAType.Class, size:2},
  "From the Beyond": {type:AAType.Class, size:2},
  "Quickening Death": {type:AAType.Class, size:1},
  "Enslaving Fire": {type:AAType.Class, size:1},
  "Feeding the Pyre": {type:AAType.Class, size:1},
  "Red Shadows of Xotli": {type:AAType.Class, size:2},
  "Hunger for More": {type:AAType.Class, size:1},
  "Unearthly Apprentice": {type:AAType.Class, size:2},
  "Supreme Lich": {type:AAType.Class, size:2},
  "Funeral Rites": {type:AAType.Class, size:1},
  "Withered Blasphemy": {type:AAType.Class, size:1},
  "Decays of Nature": {type:AAType.Class, size:1},
  "Nightmare Companions": {type:AAType.Class, size:2},
  "Chilling Breath": {type:AAType.Class, size:1},
  "Shimmering Invocation": {type:AAType.Class, size:2},
  "Emissary of Elysium": {type:AAType.Class, size:2},
  "Shield of Brilliance": {type:AAType.Class, size:1},
  "Inclusion": {type:AAType.Class, size:1},
  "Blessed Soul": {type:AAType.Class, size:1},
  "Wandering Disciple": {type:AAType.Class, size:2},
  "Light the Path": {type:AAType.Class, size:1},
  "Idol of Dark Rejuvenation": {type:AAType.Class, size:2},
  "Eyes of Set": {type:AAType.Class, size:2},
  "Leviathan's Call": {type:AAType.Class, size:1},
  "Constriction": {type:AAType.Class, size:1},
  "Forked Lightning": {type:AAType.Class, size:1},
  "Coils of the Serpent": {type:AAType.Class, size:2},
  "Lull": {type:AAType.Class, size:1},
}

class ClassImages {
  getGeneralAA() : Record<string, string>{
    return {
      "Pressing Strikes": PressingStrikes,
      "Decisive Strikes": DecisiveStrikes,
      "Chromatic Warding": ChromaticWarding,
      "Field of War": FieldOfWar,
      "Fortifying Empowerment": FortifyingEmpowerment,
      "Quick Steps": QuickSteps,
      "Immeasurable Empowerment": ImmeasurableEmpowerment,
      "Elusive Nature": ElusiveNature,
      "Precise Strikes": PreciseStrikes
    };
  }

  getArchetypeAA(archetype: AocArchetype): Record<string, string>{
    switch(archetype){
      case AocArchetype.Mage:
        return {
          "Will of the Sublime": WillOfTheSublime,
          "Unbinding Charm": UnbindingCharm,
          "Transcendence": Transcendence,
          "Enchanter": Enchanter,
          "Ethereal Escape": EtherealEscape,
        };
      case AocArchetype.Priest:
        return {
          "Empowered Mending": EmpoweredMending,
          "Steadfast Faith": SteadfastFaith,
          "Divine Luster": DivineLuster,
          "Prelate at Arms": PrelateAtArms,
          "Deliverance": Deliverance,
        };
      case AocArchetype.Rogue:
        return {
          "Arcane Plunder": ArcanePlunder,
          "Tainted Weapons": TaintedWeapons,
          "Avoid Entrapment": AvoidEntrapment,
          "Flanking": Flanking,
          "Liberation": Liberation,
        };
      case AocArchetype.Soldier:
        return {
          "Empowered Vitality": EmpoweredVitality,
          "Resolve": Resolve,
          "Avoid Entanglements": AvoidEntanglements,
          "Rear Guard": RearGuard,
          "Vindication": Vindication,
        };
      default:
        return {};
    }
  }

  getClassAA(charclass:AocClasses): Record<string,string>{
    switch(charclass){
      case AocClasses.BearShaman:
        return {
          "Sleuth of Bears": SleuthofBears,
          "Spirit of Yggdrasil": SpiritofYggdrasil,
          "Feral Growl": FeralGrowl,
          "Maul":Maul,
          "Surge of Bile":SurgeofBile,
          "Vision of the Sky":VisionsoftheSky,
          "Ursine Bond":UrsineBond,
        };
      case AocClasses.Barbarian:
        return {
          "At the Gates": AtTheGates,
          "Tools at Hand": ToolsatHand,
          "Upheaval": Upheaval,
          "Bone Shatter": BoneShatter,
          "Without Warning": WithoutWarning,
          "What it Takes":WhatitTakes,
          "Determination":Determination,
        };
      case AocClasses.Assassin:
        return {
          "Cover of Dusk": CoverofDusk,
          "Master Assassin": MasterAssassin,
          "Castration": Castration,
          "Sins of the Flesh": SinsoftheFlesh,
          "Disfigure": Disfigure,
          "Choking Powder":ChokingPowder,
          "Dance of Death":DanceofDeath,
        };
      case AocClasses.Ranger:
        return {
          "Point Blank Shot": PointBlankShot,
          "Hunting Hawk": HuntingHawk,
          "Clout": Clout,
          "Deadly Draw": DeadlyDraw,
          "Jarring Shot": JarringShot,
          "Crossfire":Crossfire,
          "Running Shot":RunningShot,
        };
      case AocClasses.Conqueror:
        return {
          "Rally": Rally,
          "One Last Push": OneLastPush,
          "Rout": Rout,
          "Besiege": Besiege,
          "Assail": Assail,
          "Battlefield Commander":BattlefieldCommander,
          "Break Through":BreakThrough,
        };
      case AocClasses.DarkTemplar:
        return {
          "Blood Shroud": BloodShroud,
          "Scarab Knight": ScarabKnight,
          "Crimson Succor": CrimsonSuccor,
          "Death Lord": DeathLord,
          "Sanguine Infusion": SanguineInfusion,
          "Void of Madness":VoidofMadness,
          "Unwilling Sacrifice":UnwillingSacrifice,
        };
      case AocClasses.Demonologist:
        return {
          "Boil Blood": BoilBlood,
          "Unleash the Underworld": UnleashtheUnderworld,
          "Cacodemon": Cacodemon,
          "Bindings of the Skylord": BindingsoftheSkylord,
          "Renegotiation": Renegotiation,
          "Ruinous Power":RuinousPower,
          "Ring of Fire": RingofFire,
        };
      case AocClasses.Guardian:
        return {
          "Stall the Advance": StallTheAdvance,
          "Prime Initiative": PrimeInitiative,
          "Deliberate Reprisal": DeliberateReprisal,
          "Counterweight": Counterweight,
          "Champion Spirit": ChampionSpirit,
          "Sustaining Wrath": SustainingWrath,
          "Master at Arms": MasteratArms,
        };
      case AocClasses.HeraldofXotli:
        return {
          "Prince of Terror": PrinceofTerror,
          "From the Beyond": FromTheBeyond,
          "Quickening Death": QuickeningDeath,
          "Enslaving Fire": EnslavingFire,
          "Feeding the Pyre": FeedingThePyre,
          "Red Shadows of Xotli": RedShadowsofXotli,
          "Hunger for More": HungerforMore,
        };
      case AocClasses.Necromancer:
        return {
          "Unearthly Apprentice": UnearthlyApprentice,
          "Supreme Lich": SupremeLich,
          "Funeral Rites": FuneralRites,
          "Withered Blasphemy": WitheredBlasphemy,
          "Decays of Nature": DecaysOfNature,
          "Nightmare Companions": NightmareCompanions,
          "Chilling Breath": ChillingBreath
        };
      case AocClasses.PriestofMitra:
        return {
          "Shimmering Invocation": ShimmeringInvocation,
          "Emissary of Elysium": EmissaryofElysium,
          "Shield of Brilliance": ShieldofBrilliance,
          "Inclusion": Inclusion,
          "Blessed Soul": BlessedSoul,
          "Wandering Disciple": WanderingDisciple,
          "Light the Path": LightthePath,
        };
      case AocClasses.TempestofSet:
        return {
          "Idol of Dark Rejuvenation": IdolofDarkRejuvenation,
          "Eyes of Set": EyesofSet,
          "Leviathan's Call": LeviathansCall,
          "Constriction": Constriction,
          "Forked Lightning": ForkedLightning,
          "Coils of the Serpent": CoilsoftheSerpent,
          "Lull": Lull,
        };
      default:
        return {};
    }
  }

  getAA(aa:string): string{
    return aaMap[aa];
  }

  getAAInfo(aa:string): {type:AAType, size:number}{
    return aaMapInfo[aa] || null;
  }
}

export const aaImages = new ClassImages();